<template>
  <sliding-modal :is-open="isOpen">
    <form @submit.prevent="subStatusSubmit" class="SUB-STATUS-BODY">
      <vk-modal-header class="HEADER" selenium="job-details-modal-header">
        <span>Update Contact Status</span>
      </vk-modal-header>
      <vk-modal-content class="d-flex fd-column p-0 BODY-CONTENT">
        <div>
          <div
              v-for="{ sub_status_name, text } in allowedSubStatuses"
              :key="sub_status_name"
              class="radio RADIO">
            <div>
              <input
                  type="radio"
                  :id="sub_status_name"
                  name="reason"
                  :value="text"
                  v-model="selectedSubStatus"
              />
              <label
                  :for="sub_status_name"
                  class="SCALED-RADIO m-r-1"
              >
                {{ text }}
              </label>
            </div>
          </div>
        </div>
      </vk-modal-content>
      <vk-modal-footer class="FOOTER">
        <button
            :disabled="isSubmitDisabled"
            class="BUTTON-PRIMARY"
        >
          Submit
        </button>
      </vk-modal-footer>
    </form>
  </sliding-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import jobParams from '@/mixins/job-params';
import job from '@/mixins/job';

import SlidingModal from '@/views/Dashboard/components/SlidingModal';

export default {
  name: 'sub-status-modal',
  components: {
    SlidingModal,
  },
  mixins: [
    jobParams,
    job,
  ],
  props: {
    isOpen: Boolean,
    phone: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      selectedSubStatus: '',
      allowedSubStatuses: [],
    };
  },
  computed: {
    ...mapGetters('account/pro/info', [
      'serviceProviderId',
    ]),
    ...mapGetters('ui', ['subStatuses']),
    isSubmitDisabled () {
      return !this.selectedSubStatus;
    },
  },
  watch: {
    isOpen () {
      if (!this.isOpen) {
        this.selectedSubStatus = '';
      }
    },
    subStatuses: {
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.allowedSubStatuses = newVal;
        }
      },
      immediate: true, // This ensures the watcher runs immediately on component mount
      deep: true, // Use deep watch if subStatuses is an array of objects
    },
  },

  methods: {
    ...mapActions('ui', ['getContactSubStatuses']),

    async subStatusSubmit () {
      this.$emit('update');
      this.$emit('primary', this.selectedSubStatus);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @import "~@/views/Dashboard/constants";

  .SUB-STATUS-BODY {
    @include responsive(min-width, 100%, $pass-modal-width);
    @include responsive(width, 100%, $pass-modal-width);
    @include responsive(max-width, 100%, $pass-modal-width);
    display: flex;
    flex-direction: column;
    @include mobile-only() {
      height: 80vh;
    }
  }
  .PHONE {
    padding: 1.5*$unit 3*$unit;
    border-bottom: 1px solid $color-gray30;
  }
  .BODY-CONTENT {
    flex: 1;
    overflow-y: auto;
  }
  .HEADER {
    @include h6;
    padding: $unit;
    font-weight: 700;
    text-align: center;
    border-bottom: 1px solid $color-gray30;
  }
  .FOOTER {
    @include responsive(justify-content, end, flex-end);
    display: flex;
    padding: 1.5*$unit 3*$unit;
  }

  .RADIO {
    display: flex;
    padding: 1.25*$unit 3*$unit;
    border-bottom: 1px solid $color-gray30;
  }
  .SCALED-RADIO {
    &:before {
      width: 2*$unit;
      height: 2*$unit;
      margin-right: 2*$unit;
    }
  }
  input:checked + label:before,
  input:focus:checked + label:before {
    box-shadow: inset 0px 0px 0px 8px $color-depot;
  }
  .BUTTON-PRIMARY {
    @include button-primary;
    @include responsive(width, 50%, 17*$unit);
    @include button-small;
    font-weight: 600;
    margin-left: $unit;
    justify-self: flex-end;
  }
  .CALL-LINK {
    @include link-primary;
    @include margin(0 -2, $md: 0);
    @include padding(1 2, $md: 1 0);
    text-decoration: underline;
    text-underline-position: under;
  }
  .REQUIRED {
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    border-bottom: 1px solid $color-gray30;
    padding: $unit;
  }
</style>
